module.exports = __webpack_public_path__ + "static/media/20-1.9fad3986.mp3";